import React from "react";
import { URLImgFront } from '../../../../config/URLDB';
import Consulta from "../Coopenautas/Consulta";

class Principal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mostrarCondiciones: false,
        };
    }

    textInput = (e) => {
        const { name, value } = e.target;
        if (name === "fecexpe") {
            const yearPart = value.split("-")[0];
            if (yearPart.length > 4) {
                this.setState({ [yearPart]: "" }); return;
            }
        }
        this.setState({ [name]: value });
    };

    render() {
        return (
            <>
                <div data-aos="fade-up" data-aos-delay="3240">
                    <div style={{ position: 'relative', width: '100%' }}>
                        <picture>
                            <source srcSet={`${URLImgFront}/assets/EstrategiasComerciales/Coopenautas/FondoMovil.webp`} media="(max-width: 768px)" />
                            <source srcSet={`${URLImgFront}/assets/EstrategiasComerciales/Coopenautas/FondoMovil.webp`} media="(max-width: 1025px )" />
                            <img className="img-fluid" style={{ width: '100%', height: 'auto', display: 'block', filter: (this.props.mostrarConsulta === true ? 'brightness(30%)' : 'brightness(100%)') }} src={`${URLImgFront}/assets/EstrategiasComerciales/Coopenautas/Portada.webp`} alt="Coopenautas" />
                        </picture>

                        {!this.props.mostrarConsulta ? (
                            <div className="aos-button-wrapper d-flex justify-content-lg-end px-md-5" data-aos="fade-right" >
                                <div className="btn-group-vertical align-items-center justify-content-end justify-content-md-center pb-5 pb-lg-0" style={{ width: "500px" }} >
                                    <button id="BtnConsultarPuntos" style={{ backgroundImage: `url(${URLImgFront}/assets/EstrategiasComerciales/Coopenautas/BtnConsultarPuntos.svg)`, width: 'clamp(200px, 80vw, 400px)', aspectRatio: '400 / 100', backgroundSize: 'cover' }} className="coopenautas-btn mb-lg-5" onClick={() => this.props.OnMostrarConsulta(true, 1)} />
                                    <button id="BtnPremios" style={{ backgroundImage: `url(${URLImgFront}/assets/EstrategiasComerciales/Coopenautas/BtnPremios.svg)`, width: 'clamp(200px, 80vw, 400px)', aspectRatio: '400 / 100', backgroundSize: 'cover' }} className="coopenautas-btn mb-lg-5" onClick={() => this.props.navegarSeccion(3)} />
                                    <button id="BtnEscuelaCoopenautas" style={{ backgroundImage: `url(${URLImgFront}/assets/EstrategiasComerciales/Coopenautas/BtnEscuelasCoopenautas.svg)`, width: 'clamp(200px, 80vw, 400px)', aspectRatio: '400 / 100', backgroundSize: 'cover' }} className="coopenautas-btn mb-lg-5" onClick={() => window.open('https://www.masparausted.com/education/', '_blank', 'noopener,noreferrer')} />
                                    <button id="BtnCondiciones" style={{ backgroundImage: `url(${URLImgFront}/assets/EstrategiasComerciales/Coopenautas/BtnTerminos&Condiciones.svg)`, width: 'clamp(200px, 80vw, 400px)', aspectRatio: '400 / 100', backgroundSize: 'cover' }} className="coopenautas-btn" onClick={() => this.setState({ mostrarCondiciones: true })} />
                                </div>
                            </div>
                        ) : (
                            <Consulta mostrarConsulta={this.props.OnMostrarConsulta} navegarSeccion={this.props.navegarSeccion} asignarDatosBasicos={this.props.asignarDatosBasicos} />
                        )}
                    </div>
                </div>

                {this.state.mostrarCondiciones && (
                    <div className="tyc-overlay" data-aos="zoom-in" onClick={() => this.setState({ mostrarCondiciones: false })}>
                        <div className="tyc-modal" onClick={(e) => e.stopPropagation()}>
                            <h5 className="text-center">Términos y Condiciones</h5>
                            <iframe src={`${URLImgFront}/assets/Archivos/TermYCondiciones_Coopenautas.pdf#toolbar=0`} width="100%" height="95%" style={{ border: 'none', borderRadius: '10px' }} title="Términos y Condiciones" ></iframe>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default Principal;